import { authQueryKeys as e } from "../queries/state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/passkeys/usePasskeyReconcileMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.passkeyReconcile,
		retry: !1,
		onSuccess: (t) => {
			!("user" in t) || !t.user || (i.invalidateQueries({ queryKey: e.me() }), i.invalidateQueries({ queryKey: e.state() }), i.removeQueries({ queryKey: ["permission"] }));
		}
	});
};
//#endregion
export { i as usePasskeyReconcileMutation };
